import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { UserDropdownComponent } from '@/layouts/components/user-dropdown.component';
import { NgOptimizedImage } from '@angular/common';
import { SystemNotificationsComponent } from '@/layouts/system-notifications/system-notifications.component';
import { UserGuidelinesComponent } from '../user-guidelines/user-guidelines.component';
import { LanguageSelectorComponent } from '../language-selector.component';
import { Button } from 'primeng/button';
import { LayoutService } from '@/shared/services/ui';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucidePanelLeftClose, lucidePanelLeftOpen } from '@ng-icons/lucide';

@Component({
  selector: 'cis-header',
  imports: [
    UserDropdownComponent,
    NgOptimizedImage,
    SystemNotificationsComponent,
    UserGuidelinesComponent,
    LanguageSelectorComponent,
    Button,
    NgIcon,
  ],
  viewProviders: [provideIcons({ lucidePanelLeftClose, lucidePanelLeftOpen })],
  template: `
    <header
      class="fixed w-full h-4rem z-5 pr-4 pl-3 py-2 border-gray-200 flex align-items-center justify-content-between"
      [style.background-color]="'white'">
      <div class="flex align-items-center gap-2">
        <p-button text rounded severity="secondary" (onClick)="toggleSidebar()">
          <ng-icon [name]="layoutService.sidebarVisible() ? 'lucidePanelLeftClose' : 'lucidePanelLeftOpen'" size="24" color="black" />
        </p-button>
        <img ngSrc="/branding/logos/regular/SVG/logo%202%20lines.svg" width="156" height="50" alt="fimpact4" priority />
      </div>
      <div class="flex align-items-center" [style.gap.px]="32" [style.min-width.px]="212">
        <cis-language-selector />
        <cis-system-notifications />
        <cis-user-guidelines />
        <cis-user-dropdown />
      </div>
    </header>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  protected readonly layoutService = inject(LayoutService);

  toggleSidebar() {
    this.layoutService.sidebarVisible.update((v) => !v);
  }
}
